<div class="modal-dialog modal-xl mt-0 mb-0" role="document">
    <div class="modal-content" style="min-height: 450px;">
        <div class="modal-body">
            <button *ngIf="!isLoginSiga" type="button" aria-label="Close" (click)="bsModalRef.hide()" class="btn-close btn-danger float-end"
                data-bs-dismiss="modal" aria-label="Close">
            </button>

            <div class="col-lg-12 col-md-12 col-sm-12 mb-4">
                <h4 class="titulo_seccao">Validação do veículo</h4>
            </div>

            <form [formGroup]="resourceForm" class="formDev">
                <div class="row">
                    <app-input-field-hide formControlName="protocolo"></app-input-field-hide>
                    <div class="input-dados-disable">
                        <app-select-field-search-tag [hidden]="isReadOnly" [itens]="marcas" (change)="onChangeMarca($event)"
                            label="Marca" formControlName="marca_codigo" [isReadOnly]="isReadOnly">
                        </app-select-field-search-tag>
                        <app-input-field [hidden]="!isReadOnly" label="Marca" formControlName="marca_descricao"
                            [isReadOnly]="isReadOnly">
                        </app-input-field>
                    </div>
                    <div class="input-dados-disable">
                        <app-select-field-search-tag [hidden]="isReadOnly" [itens]="geracoes"
                            (change)="onChangeGeracao($event)" label="Geração" formControlName="geracao_codigo"
                            [isReadOnly]="isReadOnly">
                        </app-select-field-search-tag>
                        <app-input-field [hidden]="!isReadOnly" label="Geração" formControlName="geracao_descricao"
                            [isReadOnly]="isReadOnly">
                        </app-input-field>
                    </div>
                    <div class="input-dados-disable">
                        <app-select-field-search-tag [hidden]="isReadOnly" [itens]="modelos"
                            (change)="onChangeModelo($event)" label="Modelo" formControlName="modelo_codigo"
                            [isReadOnly]="isReadOnly">
                        </app-select-field-search-tag>
                        <app-input-field [hidden]="!isReadOnly" label="Modelo" formControlName="modelo_descricao"
                            [isReadOnly]="isReadOnly">
                        </app-input-field>
                    </div>
                    <div class="input-dados-disable">
                        <app-select-field-search [hidden]="isReadOnly" [itens]="versoes"
                            (change)="onChangeVersao($event)" label="Versao" formControlName="versao_codigo"
                            [isReadOnly]="isReadOnly">
                        </app-select-field-search>
                        <app-input-field [hidden]="!isReadOnly" label="Versão" formControlName="versao_descricao"
                            [isReadOnly]="isReadOnly">
                        </app-input-field>
                    </div>
                    <div class="input-dados-disable">
                        <app-select-field-search [hidden]="isReadOnly" [itens]="veiculos" label="Veiculo"
                            (change)="onChangeVeiculo($event)" formControlName="veiculo_codigo"
                            [isReadOnly]="isReadOnly">
                        </app-select-field-search>
                        <app-input-field [hidden]="!isReadOnly" label="Veiculo" formControlName="veiculo_descricao"
                            [isReadOnly]="isReadOnly">
                        </app-input-field>
                    </div>
                    <div class="input-dados-disable">
                        <app-input-field label="Placa" formControlName="placa" [isReadOnly]="isReadOnly" mask="AAAAAAA">
                        </app-input-field>
                    </div>
                    <div class="col-lg-3">
                        <app-select-field-search [itens]="coresVeiculo" label="Cor" formControlName="cor">
                        </app-select-field-search>
                    </div>
                    <div class="col-lg-3">
                        <app-input-field type="text" label="Quilometragem" formControlName="quilometragem"
                            onkeypress="return (event.charCode >= 48 && event.charCode <= 57)||(event.charCode == 44)||(event.charCode == 46)">
                        </app-input-field>
                    </div>
                    <div class="col-lg-3">
                        <app-select-field [itens]="nivel" label="Nível de Combustivel" [isReadOnly]="isReadOnly"
                            (change)="onChangeCombustivel()" formControlName="combustivel"></app-select-field>
                    </div>
                    <div class="col-lg-3 upper">
                        <app-input-field type="text" label="Chassi" formControlName="chassi" maxlength="17"
                            mask="AAAAAAAAAAAAAAAAA"
                            (input)="this.resourceForm.get('chassi').setValue($event.target.value.toUpperCase())">
                        </app-input-field>
                    </div>
                    <!-- <div class="col-12">
                        <app-select-field-search label="Empresa" formControlName="usuarioEmpresa" [itens]="responsavel" [disabled]="!(checkIdGroup([1,2,3,4,5,6,7,8]))"
                            (change)="onSelectEmp()">
                        </app-select-field-search>
                    </div>
                    <div class="col-12">
                        <app-select-field-search label="Usuario" formControlName="usuario" [itens]="responsaveis" [disabled]="!(checkIdGroup([1,2,3,4,5,6,7,8]))">
                        </app-select-field-search>
                    </div> -->
                    <!--          <div class="row gx-0 d-flex justify-content-center ">
                    <h4 class="text-center mb-4 ">Nível de combustível</h4>
                    <div class="col-md-2">

                    
                    
                    </div>
                    <app-progress-bar [width]="progress_width" [background]="progress_color"></app-progress-bar>
                    <span class="text-center">{{progress_width}}</span>
                </div> -->

                </div>
            </form>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="!(checkIdGroup([1,2,3,4,5,6,7,8]))">Confirmar</button>
            <button type="button" class="btn btn-warning" [disabled]="!isReadOnly"
                (click)="enableAlterar()" [disabled]="!(checkIdGroup([1,2,3,4,5,6,7,8]))">Alterar</button>
            <button *ngIf="!isLoginSiga" id="closeModal" type="button" class="btn btn-danger" data-bs-dismiss="modal"
                (click)="bsModalRef.hide()">Cancelar</button>
        </div>
    </div>
</div>